import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, OPERATION_MODE, PATTERNS, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet, sequenceActionNext, useForm } from '@laramie/ui';
import { useLista } from '../../components/hooks/useLista';
import { APIS } from '../../config/apis';

import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import { ServerRequest } from '../../utils/apiweb';
import { standardRequest } from '../../utils/requests';

import { FormError, Loading, InputEntidad, InputLista, DatePickerCustom, SectionHeading, InputSecret, FormLabel, CheckboxButton } from '../../components/common';
import { isEmptyString } from '../../utils/validator';
import { getDateId, getDateNow } from '../../utils/convert';
import { CloneObject, CompareDates } from '../../utils/helpers';
import DireccionForm, {GetDataDireccion, IsValidDireccion} from '../../components/controls/DireccionForm';
import DataTaggerFormRedux from '../../components/controls/DataTaggerFormRedux';
import DocumentosGrid from '../../components/controls/DocumentosGrid';
import ContactosGrid from '../../components/controls/ContactosGrid';
import MediosPagoGrid from '../../components/controls/MediosPagoGrid';
import ArcaLookup from '../../components/controls/ArcaLookup';
import ArcaActualizacion from '../../components/controls/ArcaActualizacion';
import useArcaIntegration, { mapArcaDomicilio } from '../../hooks/useArcaIntegration';
import useArcaActualizacion, { identificacionArca, documentosArca, domicilioArcaCompleto } from '../../hooks/useArcaActualizacion';
import { TIPO_PERSONA, TIPO_DOCUMENTO, ARCA_SEXO_A_GENERO } from '../../consts/entityType';
import { TIPO_CONTACTO_EMAIL_PORTAL } from '../../consts/contactoTypes';

import userProfile from '../../assets/images/user-profile.png';
import userProfileMan from '../../assets/images/user-profile-man.png';
import userProfileWoman from '../../assets/images/user-profile-woman.png';
import { useAccess, useFormErrors, useManagedContext, useNav, useUnsavedChangesGuard } from '../../components/hooks';
import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { TIPS } from '../../consts/tips';

import './index.scss'; 

function PersonaFisicaView() {
     
    //parametros url
    const params = useParams();
    const navigate = useNav()
    const { showMessageModal } = useManagedContext()

    //#region Variables
    const entityInit = {
        persona: {
            id: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            idNacionalidad: 0,
            nombre: '',
            apellido: '',
            idGenero: 0,
            idEstadoCivil: 0,
            idNivelEstudio: 0,
            profesion: '',
            matricula: '',
            fechaNacimiento: null,
            fechaDefuncion: null,
            discapacidad: false,
            idCondicionFiscal: 0,
            idIngresosBrutos: 0,
            ganancias: false,
            pin: '',
            foto: '',
            origen: ''
        },
        direccion: {
          id: 0,
          entidad: "PersonaFisica",
          idEntidad: 0,
          idTipoGeoreferencia: 0,
          idPais: 0,
          idProvincia: 0,
          idLocalidad: 0,
          idZonaGeoreferencia: 0,
          codigoPostal: "",
          calle: "",
          entreCalle1: "",
          entreCalle2: "",
          altura: "",
          piso: "",
          dpto: "",
          referencia: "",
          longitud: 0,
          latitud: 0,
          origen: ""
        },
        archivos: [],
        observaciones: [],
        etiquetas: [],
        documentos: [],
        contactos: [],
        mediosPago: []
    };
    //#endregion

    //#region Hooks
    const [state, setState] = useState({
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        showInfo: false,
        accordions: {
            datos: true,
            documentos: false,
            contactos: false,
            direcciones: false,
            mediosPago: false,
            datosImpositivos: false,
            estudios: false
        }
    });

    const [pendingChange, setPendingChange] = useState(false);

    const refInputFileFoto = useRef(null);

    const [processKey, setProcessKey] = useState(null);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);

    const mount = () => {
        
        const _processKey = `PersonaFisica_${state.id??0}_${getDateId()}`;
        setProcessKey(_processKey);

        if (state.id > 0) {
            FindPersonaFisica();
        }
        else {
            dispatch(dataTaggerActionSet(_processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
        }

        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [accessMedioPago, setAccessMedioPago] = useState({view: false, edit: false});
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const medio_pago_view = access.some(f => f.codigo === 'medio-pago_view');
            const medio_pago_edit = access.some(f => f.codigo === 'medio-pago_edit');
            setAccessMedioPago({view: medio_pago_view, edit: medio_pago_edit});
        }
    }, [readyAceess]);

    useEffect(() => {
        if (processKey && state.entity.persona.id > 0) {
            dispatch(dataTaggerActionSet(processKey, {
                Archivo: state.entity.archivos,
                Observacion: state.entity.observaciones,
                Etiqueta: state.entity.etiquetas
            }));        
        }
    }, [processKey, state.entity]);

    const formInitialValues = {
        idTipoDocumento: 0,
        numeroDocumento: '',
        idNacionalidad: 0,
        nombre: '',
        apellido: '',
        idGenero: 0,
        idEstadoCivil: 0,
        idNivelEstudio: 0,
        profesion: '',
        matricula: '',
        fechaNacimiento: null,
        fechaDefuncion: null,
        discapacidad: false,
        idCondicionFiscal: 0,
        idIngresosBrutos: 0,
        ganancias: false,
        pin: '',
        foto: ''
    };
    const [ formValues, formHandle, , formSet ] = useForm(formInitialValues);

    const arca = useArcaIntegration({
        isNew: state.mode === OPERATION_MODE.NEW,
        tipoPersonaEsperado: 'FISICA',
        mapearFormValues: (persona) => ({
            ...(persona.nombre && { nombre: persona.nombre }),
            ...(persona.apellido && { apellido: persona.apellido }),
            ...(ARCA_SEXO_A_GENERO[persona.sexo] && { idGenero: ARCA_SEXO_A_GENERO[persona.sexo] }),
            ...(persona.fechaNacimiento && { fechaNacimiento: new Date(persona.fechaNacimiento + 'T12:00:00') }),
        }),
        mapearDomicilios: (persona, entity, idDocumento) => {
            const dom = persona.domicilioFiscal || persona.domicilioLegal;
            if (dom) entity.direccion = { ...entity.direccion, ...mapArcaDomicilio(dom) };
            if (persona.numeroDocumento && persona.tipoDocumento === 'DNI') {
                entity.documentos.push({
                    id: idDocumento,
                    idTipoPersona: TIPO_PERSONA.FISICA,
                    idPersona: 0,
                    idTipoDocumento: TIPO_DOCUMENTO.DNI,
                    numeroDocumento: persona.numeroDocumento,
                    principal: false,
                    state: 'a'
                });
            }
            return entity;
        },
        camposArca: (data) => ({
            nombre: !!data.nombre,
            apellido: !!data.apellido,
            idGenero: !!ARCA_SEXO_A_GENERO[data.sexo],
            fechaNacimiento: !!data.fechaNacimiento,
        }),
        formValues, formSet, setState, setPendingChange,
    });

    const verifiedData = useMemo(() =>
        state.entity.persona.origen === 'PORTAL_WEB' ||
        state.entity.persona.origen === 'VERIFICADO'
    );
    //el email con el que la persona se dio de alta desde el portal no se modifica: el portal lo guarda antes que
    //cualquier otro contacto y, como no se puede borrar, sigue siendo el de menor id
    const idEmailAlta = useMemo(() => {
        if (!verifiedData) return null;
        const emails = state.entity.contactos.filter(f => f.id > 0 && f.idTipoContacto === TIPO_CONTACTO_EMAIL_PORTAL);
        return (emails.length > 0) ? Math.min(...emails.map(f => f.id)) : null;
    }, [verifiedData, state.entity.contactos]);
    const arcaOrigen = state.entity.persona.origen === 'ARCA';
    const arcaNombreIncompleto = !!arca.arcaData && (!arca.arcaData.nombre || !arca.arcaData.apellido);
    // El documento del encabezado: hay físicas migradas con el CUIT sólo ahí, sin una fila en la grilla
    const cabecera = { idTipoDocumento: formValues.idTipoDocumento, numeroDocumento: formValues.numeroDocumento };

    const actualizacionArca = useArcaActualizacion({
        persona: state.entity.persona,
        disponible: state.mode === OPERATION_MODE.EDIT && state.entity.persona.id > 0 && !verifiedData,
        camposAlta: ['nombre', 'apellido', 'direccion'],
        domicilios: ['direccion'],
    });
    // domicilio de ARCA aplicado en la edición: el formulario se vuelve a montar en cada aplicación para georreferenciarlo
    const domicilioArca = actualizacionArca.domicilioAplicado('direccion');

    const dispatch = useDispatch();
    const dataTagger = useSelector( (state) => state.dataTagger.data );
    const sequenceValue = useSelector( (state) => state.sequence.value );
  
    const [getListLista, ] = useLista({
        listas: ['TipoGeoreferencia'],
        onLoaded: (listas, isSuccess, error) => {
          if (isSuccess) {
            const listTipoGeoreferencia = getListLista('TipoGeoreferencia');
            const idTipoGeoreferencia = (listTipoGeoreferencia.length > 0) ? listTipoGeoreferencia[0].id : 530; //el primero u Open Street Map
            setState(prevState => {
                let data = CloneObject(prevState.entity);
                data.direccion.idTipoGeoreferencia = idTipoGeoreferencia;
                return {...prevState, entity: data};
            });
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoGeoreferencia',
          timeout: 0
        }
    });

    const isNoHeader = useMemo(() => window.location.pathname.split('/')[2] === 'nh', [window.location.pathname])

    const arcaAutoGeocodeAddress = useMemo(() => {
        const dom = arca.arcaData?.domicilioFiscal || arca.arcaData?.domicilioLegal || domicilioArca?.domicilio;
        return dom ? { country: 'ARGENTINA', state: dom.descripcionProvincia, city: dom.localidad, street: dom.calle, number: dom.numero } : null;
    }, [arca.arcaData, domicilioArca]);

    const maxFechaNacimiento = useMemo(() => {
        const d = getDateNow();
        d.setHours(23, 59, 59, 999);
        d.setFullYear(d.getFullYear() - 16);
        return d;
    }, []);

    const today = useMemo(() => getDateNow(), []);

    const getErrors = () => {
        const errors = {};

        if (formValues.idNacionalidad <= 0) errors.idNacionalidad = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.nombre.length === 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.apellido.length === 0) errors.apellido = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idGenero <= 0) errors.idGenero = VALIDATION_MESSAGE.REQUIRED_SHORT;

        if (formValues.fechaNacimiento != null) {
            if (CompareDates(formValues.fechaNacimiento, today) > 0) errors.fechaNacimiento = 'No puede ser posterior a hoy';
            else if (CompareDates(formValues.fechaNacimiento, maxFechaNacimiento) > 0) errors.fechaNacimiento = 'Debe tener al menos 16 años';
        }

        if (formValues.fechaDefuncion != null && CompareDates(formValues.fechaDefuncion, today) > 0) {
            errors.fechaDefuncion = 'No puede ser posterior a hoy';
        }

        return errors;
    }

    const getFormatErrors = () => {
        const errors = {};

        if (state.mode === OPERATION_MODE.VIEW) return errors;

        if (formValues.fechaDefuncion != null && formValues.fechaNacimiento != null
            && CompareDates(formValues.fechaDefuncion, formValues.fechaNacimiento) < 0) {
            errors.fechaDefuncion = 'Anterior al nacimiento';
        }

        return errors;
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);
    //#endregion

    //#region Handles
    const formHandleProxy = (event) => {
        formHandle(event);
        setPendingChange(true);
    }
    const openAccordion = (accordion) => {
        setState(prevState => {
            return {...prevState, accordions: {...prevState.accordions, [accordion]: true}};
        });
    }
    const handleClickGuardar = () => {
        if (formValues.idTipoDocumento <= 0 || formValues.numeroDocumento.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe ingresar un Documento');
            openAccordion('documentos');
            return;
        }

        if (!validate()) {
            openAccordion('datos');
            return;
        }

        const isValidDireccion = IsValidDireccion.get("PersonaFisica_direccion")();
        if (!isValidDireccion.result) {
            openAccordion('direcciones');
            if (isValidDireccion.message) ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
            return;
        }

        if (state.id === 0) {
            AddPersonaFisica();
        }
        else {
            ModifyPersonaFisica();
        }
    }    
    const handleClickVolver = () => {
        if (!pendingChange) dispatch(dataTaggerActionClear(processKey));
        
        if (!isNoHeader) navigate({ to: `/personas-fisicas` })
        else if (pendingChange) showMessageModal({
            ...MESSAGE_MODALS.CONFIRM_SALIR, onConfirm: () => {
                allowNavigation();
                window.close();
            },
        })
        else window.close()
    }
    const handleInputFileFotoChange = (event) => {
        if (event.target.files.length === 0) {
            event.preventDefault();
            return;
        }

        let file = event.target.files[0];
        let reader = new FileReader();

        reader.onload = (e) => {
            const urlFoto = e.target.result;
            formSet({...formValues, foto: urlFoto});
        }
        reader.onerror = (error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        }
        setPendingChange(true);
        reader.readAsDataURL(file);
        event.target.value = "";
    }
    const handleClickRermoveFoto = () => {
        formSet({...formValues, foto: ""});
    }
    //#endregion
    
    //#region Callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindPersonaFisica = (response) => {
        response.json()
        .then((data) => {
            if (data.persona.fechaNacimiento) data.persona.fechaNacimiento = new Date(data.persona.fechaNacimiento);
            if (data.persona.fechaDefuncion) data.persona.fechaDefuncion = new Date(data.persona.fechaDefuncion);

            data.mediosPago.forEach(x => {
                if (x.fechaVencimiento) x.fechaVencimiento = new Date(x.fechaVencimiento);
            });

            setState(prevState => {
                return {...prevState, loading: false, entity: data};
            });
            setPendingChange(false);
            formSet({
                idTipoDocumento: data.persona.idTipoDocumento,
                numeroDocumento: data.persona.numeroDocumento,
                idNacionalidad: data.persona.idNacionalidad,
                nombre: data.persona.nombre,
                apellido: data.persona.apellido,
                idGenero: data.persona.idGenero,
                idEstadoCivil: data.persona.idEstadoCivil,
                idNivelEstudio: data.persona.idNivelEstudio,
                profesion: data.persona.profesion,
                matricula: data.persona.matricula,
                fechaNacimiento: data.persona.fechaNacimiento,
                fechaDefuncion: data.persona.fechaDefuncion,
                discapacidad: data.persona.discapacidad,
                idCondicionFiscal: data.persona.idCondicionFiscal,
                idIngresosBrutos: data.persona.idIngresosBrutos,
                ganancias: data.persona.ganancias,
                pin: data.persona.pin,
                foto: data.persona.foto               
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    //#endregion

    //#region Functions
    function FindPersonaFisica() {
        
        setState(prevState => {
        return {...prevState, loading: true};
        });

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PERSONA_FISICA,
            paramsUrl,
            null,
            callbackSuccessFindPersonaFisica,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddPersonaFisica() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((row) => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Persona física ingresada correctamente", () => {
                    dispatch(dataTaggerActionClear(processKey));

                    allowNavigation();
                    if (isNoHeader) window.close()
                    else navigate({ to: `/persona-fisica/edit/${row.persona.id}`, refresh: true, replace: true })
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
        };

        const dataBody = {
            persona: {
                ...state.entity.persona,
                idTipoDocumento: parseInt(formValues.idTipoDocumento),
                numeroDocumento: formValues.numeroDocumento,
                idNacionalidad: parseInt(formValues.idNacionalidad),
                nombre: formValues.nombre,
                apellido: formValues.apellido,
                idGenero: parseInt(formValues.idGenero),
                idEstadoCivil: !isEmptyString(formValues.idEstadoCivil) ? parseInt(formValues.idEstadoCivil) : 0,
                idNivelEstudio: !isEmptyString(formValues.idNivelEstudio) ? parseInt(formValues.idNivelEstudio) : 0,
                profesion: formValues.profesion,
                matricula: formValues.matricula,
                fechaNacimiento: formValues.fechaNacimiento,
                fechaDefuncion: formValues.fechaDefuncion,
                discapacidad: formValues.discapacidad,
                idCondicionFiscal: !isEmptyString(formValues.idCondicionFiscal) ? parseInt(formValues.idCondicionFiscal) : 0,
                idIngresosBrutos: !isEmptyString(formValues.idIngresosBrutos) ? parseInt(formValues.idIngresosBrutos) : 0,
                ganancias: formValues.ganancias,
                pin: formValues.pin,
                foto: formValues.foto,
                origen: state.entity.persona.origen
            },
            direccion: GetDataDireccion.get("PersonaFisica_direccion")(),
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : [],
            documentos: state.entity.documentos.filter(f => f.state !== 'o'),
            contactos: state.entity.contactos.filter(f => f.state !== 'o'),
            mediosPago: state.entity.mediosPago.filter(f => f.state !== 'o'),
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.PERSONA_FISICA,
            null,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }    

    function ModifyPersonaFisica() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Persona física actualizada correctamente", () => {
                dispatch(dataTaggerActionClear(processKey));
                actualizacionArca.reiniciar();
                callbackSuccessFindPersonaFisica(response);
                //const url = APPCONFIG.SITE.WEBAPP + 'personas-fisicas';
                //window.location.href = url;
            });
        };

        const dataBody = {
            persona: {
                ...state.entity.persona,
                idTipoDocumento: parseInt(formValues.idTipoDocumento),
                numeroDocumento: formValues.numeroDocumento,
                idNacionalidad: parseInt(formValues.idNacionalidad),
                nombre: formValues.nombre,
                apellido: formValues.apellido,
                idGenero: parseInt(formValues.idGenero),
                idEstadoCivil: !isEmptyString(formValues.idEstadoCivil) ? parseInt(formValues.idEstadoCivil) : 0,
                idNivelEstudio: !isEmptyString(formValues.idNivelEstudio) ? parseInt(formValues.idNivelEstudio) : 0,
                profesion: formValues.profesion,
                matricula: formValues.matricula,
                //la de una persona del portal está bloqueada: va la guardada, porque al abrir la ficha el selector
                //vacía la que pasa el tope de 16 años
                fechaNacimiento: (verifiedData) ? state.entity.persona.fechaNacimiento : formValues.fechaNacimiento,
                fechaDefuncion: formValues.fechaDefuncion,
                discapacidad: formValues.discapacidad,
                idCondicionFiscal: !isEmptyString(formValues.idCondicionFiscal) ? parseInt(formValues.idCondicionFiscal) : 0,
                idIngresosBrutos: !isEmptyString(formValues.idIngresosBrutos) ? parseInt(formValues.idIngresosBrutos) : 0,
                ganancias: formValues.ganancias,
                pin: formValues.pin,
                foto: formValues.foto,
                origen: state.entity.persona.origen,
                ...actualizacionArca.marca()
            },
            direccion: GetDataDireccion.get("PersonaFisica_direccion")(),
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : [],
            documentos: state.entity.documentos.filter(f => f.state !== 'o'),
            contactos: state.entity.contactos.filter(f => f.state !== 'o'),
            mediosPago: state.entity.mediosPago.filter(f => f.state !== 'o'),
        };
        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PERSONA_FISICA,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function numerosDocumento(idTipoDocumento) {
        const numeros = state.entity.documentos
            .filter(f => f.state !== 'r' && parseInt(f.idTipoDocumento) === idTipoDocumento)
            .map(f => f.numeroDocumento);
        if (numeros.length === 0 && parseInt(cabecera.idTipoDocumento) === idTipoDocumento) numeros.push(cabecera.numeroDocumento);
        return numeros.join(', ');
    }

    function FilasArca(persona) {
        const fechaNacimiento = persona.fechaNacimiento ? new Date(persona.fechaNacimiento + 'T12:00:00') : null;
        // con el nombre entero en un solo campo (LAR-1776), aplicarlo deja separarlo a mano: no viene elegido
        const nombreCompleto = !!persona.nombre && !!persona.apellido;
        return [
            { campo: 'nombre', etiqueta: 'Nombre', actual: formValues.nombre, arca: persona.nombre, aMano: !nombreCompleto },
            { campo: 'apellido', etiqueta: 'Apellido', actual: formValues.apellido, arca: persona.apellido, aMano: !nombreCompleto },
            { campo: 'idGenero', etiqueta: 'Género', tipo: 'lista', lista: 'Genero', actual: formValues.idGenero, arca: ARCA_SEXO_A_GENERO[persona.sexo] ?? 0 },
            // el formulario no admite una fecha posterior a su tope: la vaciaría sin avisar y se perdería la que había
            { campo: 'fechaNacimiento', etiqueta: 'Fecha de nacimiento', tipo: 'fecha', actual: formValues.fechaNacimiento, arca: fechaNacimiento,
              motivo: (fechaNacimiento && CompareDates(fechaNacimiento, maxFechaNacimiento) > 0) ? 'Menor de 16 años' : undefined },
            { campo: 'cuit', etiqueta: 'CUIT', actual: numerosDocumento(TIPO_DOCUMENTO.CUIT), arca: persona.cuit },
            { campo: 'dni', etiqueta: 'DNI', tipo: 'numero', actual: numerosDocumento(TIPO_DOCUMENTO.DNI), arca: (persona.tipoDocumento === 'DNI') ? persona.numeroDocumento : '' },
            { campo: 'direccion', etiqueta: 'Domicilio personal', tipo: 'direccion', actual: GetDataDireccion.get("PersonaFisica_direccion")(),
              arca: persona.domicilioFiscal || persona.domicilioLegal },
        ];
    }

    // Un documento de ARCA que la persona no tiene y ya está cargado en otra no se puede aplicar: el guardado se
    // rechazaría entero sin decir por cuál. Se consulta y se avisa como en el modal de documentos.
    function DocumentosArcaDeOtrasPersonas(persona) {
        return Promise.all(['cuit', 'dni'].map(campo => {
            const [documento] = documentosArca([campo], persona, state.entity.documentos,
                { idTipoPersona: TIPO_PERSONA.FISICA, idPersona: state.id, idInicial: 1 });
            if (!documento) return null;
            const path = APIS.URLS.PERSONA_FISICA +
                `/check-documento-duplicado?idTipoDocumento=${documento.idTipoDocumento}` +
                `&numeroDocumento=${encodeURIComponent(documento.numeroDocumento)}` +
                `&excludeIdPersona=${state.id}`;
            return standardRequest(REQUEST_METHOD.GET, path, null, { disableToast: true })
                .then(data => {
                    if (!data?.duplicado) return null;
                    const nombre = [data.persona?.nombre, data.persona?.apellido].filter(Boolean).join(' ');
                    return [campo, `Ya existe una persona física con ese documento${nombre ? ': ' + nombre : ''}`];
                })
                // si la verificación falla no se frena al operador, como en el modal
                .catch(() => null);
        }))
        .then(motivos => Object.fromEntries(motivos.filter(Boolean)));
    }

    // Pasa al formulario sólo lo que el operador eligió: no guarda, no quita documentos y deja el resto como estaba. Lo
    // elegido que ya era igual (`iguales`) no se reescribe: queda lo que estaba, con sus tildes, y cuenta como completado
    function AplicarArca(campos, persona, iguales) {
        const updates = {};
        const completados = [];
        const reescribir = campo => campos.includes(campo) && !iguales.includes(campo);
        // con el nombre partido en un solo campo, nombre y apellido quedan editables (LAR-1776), aunque estuvieran
        // bloqueados: el operador tiene que poder separarlo
        const nombreCompleto = !!persona.nombre && !!persona.apellido;
        const nombrePartido = !nombreCompleto && (campos.includes('nombre') || campos.includes('apellido'));
        if (reescribir('nombre')) updates.nombre = persona.nombre;
        if (reescribir('apellido')) updates.apellido = persona.apellido;
        if (nombreCompleto) completados.push(...['nombre', 'apellido'].filter(campo => campos.includes(campo)));
        if (campos.includes('idGenero')) {
            if (reescribir('idGenero')) updates.idGenero = ARCA_SEXO_A_GENERO[persona.sexo];
            completados.push('idGenero');
        }
        if (campos.includes('fechaNacimiento')) {
            if (reescribir('fechaNacimiento')) updates.fechaNacimiento = new Date(persona.fechaNacimiento + 'T12:00:00');
            completados.push('fechaNacimiento');
        }

        const documentos = documentosArca(campos, persona, state.entity.documentos,
            { idTipoPersona: TIPO_PERSONA.FISICA, idPersona: state.id, idInicial: sequenceValue || 1, cabecera });
        documentos.forEach(() => dispatch(sequenceActionNext()));
        const principal = documentos.find(f => f.principal);
        if (principal) {
            updates.idTipoDocumento = principal.idTipoDocumento;
            updates.numeroDocumento = principal.numeroDocumento;
        }

        // el domicilio igual tampoco se reemplaza: no pierde entrecalles ni referencia ni se vuelve a georreferenciar
        const dom = persona.domicilioFiscal || persona.domicilioLegal;
        const direccion = (reescribir('direccion') && dom) ? {
            ...GetDataDireccion.get("PersonaFisica_direccion")(),
            entreCalle1: '', entreCalle2: '', referencia: '', idZonaGeoreferencia: 0, latitud: 0, longitud: 0,
            ...mapArcaDomicilio(dom)
        } : null;
        // igual o distinto, se bloquea sólo si ARCA lo trajo completo: si no, pierde el bloqueo que tenía, así se completa
        const reemplazados = nombrePartido ? ['nombre', 'apellido'] : [];
        if (campos.includes('direccion') && dom) {
            if (domicilioArcaCompleto(dom)) completados.push('direccion');
            else reemplazados.push('direccion');
        }

        formSet({...formValues, ...updates});
        setState(prevState => {
            let entity = CloneObject(prevState.entity);
            entity.documentos = [...prevState.entity.documentos, ...documentos];
            if (direccion) entity.direccion = direccion;
            return {...prevState, entity: entity};
        });
        actualizacionArca.registrar(completados, direccion ? { direccion: dom } : {}, reemplazados);
        actualizacionArca.cerrar();
        setPendingChange(true);
    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs

        let entity = CloneObject(state.entity);

        if (typeEntity === 'Documento') {
            if (row.state === 'a') {
                entity.documentos.push(row);
            }
            else if (row.state === 'm') {
                const index = entity.documentos.indexOf(entity.documentos.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.documentos[index] = row;
                }
            }
            else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.documentos = entity.documentos.filter(f => f.id !== row.id);
                }
                else {
                    let item = entity.documentos.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }

            const principal = entity.documentos.find(x => x.principal && x.state !== 'r');
            if (principal.idTipoDocumento !== parseInt(formValues.idTipoDocumento) || 
                principal.numeroDocumento !== formValues.numeroDocumento) {
                formSet({...formValues,
                    idTipoDocumento: principal.idTipoDocumento,
                    numeroDocumento: principal.numeroDocumento               
                });
            }

        }

        if (typeEntity === 'Contacto') {
            if (row.state === 'a') {
                entity.contactos.push(row);
            }
            else if (row.state === 'm') {
                const index = entity.contactos.indexOf(entity.contactos.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.contactos[index] = row;
                }
            }
            else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.contactos = entity.contactos.filter(f => f.id !== row.id);
                }
                else {
                    let item = entity.contactos.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'MedioPago') {
            if (row.state === 'a') {
                entity.mediosPago.push(row);
            }
            else if (row.state === 'm') {
                const index = entity.mediosPago.indexOf(entity.mediosPago.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.mediosPago[index] = row;
                }
            }
            else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.mediosPago = entity.mediosPago.filter(f => f.id !== row.id);
                }
                else {
                    let item = entity.mediosPago.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }


    function getFoto(idGenero, foto) {
        if (foto.length > 0)
            return foto;
        else if (idGenero === 560)
            return userProfileMan;
        else if (idGenero === 561)
            return userProfileWoman;
        else
            return userProfile;
    }

    function ToggleAccordionInfo() {
        setState(prevState => {
            return {...prevState, showInfo: !prevState.showInfo};
        });
    }
    function ToggleAccordion(accordion) {
        let accordions = CloneObject(state.accordions);
        accordions[accordion] = !accordions[accordion];
        setState(prevState => {
            return {...prevState, accordions: accordions};
        });
    }
    //#endregion

    const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
    const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>



    return (
    <>

        <Loading visible={state.loading}></Loading>

        <SectionHeading
            titles={[
                'Personas',
                { title: 'Físicas', url: '/personas-fisicas' },
                params.mode === OPERATION_MODE.NEW ? 'Nueva' : `Documento: ${formValues.numeroDocumento}`
            ]}
        />

        {arca.showArcaLookup && (
            <ArcaLookup
                tipoPersonaEsperado="FISICA"
                onPersonaFound={arca.handlePersonaFound}
                onSkip={arca.handleSkip}
            />
        )}

        {!arca.showArcaLookup && (<>
        <div className="m-top-20">

            <section className='section-accordion'>

                <div className="m-top-20 m-bottom-20">

                    <div className="form-content m-left-20">
                        <div className='row'>
                            <div className={`mb-3 col-12 ${actualizacionArca.visible ? 'col-md' : 'col-md-5'}`}>
                                <label htmlFor="nombre" className="form-label">Nombre y apellido</label>
                                <div className="mb-3 col-md-12">
                                    <input
                                        name="nombre"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={ `${formValues.nombre} ${formValues.apellido}` }
                                        disabled={true}
                                    >
                                    </input>
                                </div>
                            </div>
                            <div className="mb-3 col-12 col-md-2">
                                <label htmlFor="idTipoDocumento" className="form-label">Tipo de documento</label>
                                <InputLista
                                    name="idTipoDocumento"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.idTipoDocumento }
                                    disabled={true}
                                    lista="TipoDocumento"
                                />
                            </div>
                            <div className="mb-3 col-10 col-md-2">
                                <label htmlFor="numeroDocumento" className="form-label">Número de documento</label>
                                <input
                                    name="numeroDocumento"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.numeroDocumento }
                                    disabled={true}
                                />
                            </div>
                            <div className="mb-3 col-2 col-md-1">
                                <div className="text-left m-top-32" title="Verificado">
                                    <span
                                        title={verifiedData ? "Verificado" : arcaOrigen ? "Verificado (ARCA)" : ""}
                                        className={(verifiedData || arcaOrigen) ? "material-symbols-outlined verified-data" : "material-symbols-outlined unverified-data"}
                                    >
                                        Verified
                                    </span>
                                </div>
                            </div>
                            {actualizacionArca.visible &&
                            <div className="mb-3 col-12 col-md-auto">
                                <button className="btn btn-outline-primary text-nowrap m-top-32" onClick={actualizacionArca.abrir}>
                                    Actualizar desde ARCA
                                </button>
                            </div>
                            }
                        </div>
                    </div>

                    {actualizacionArca.abierta &&
                        <ArcaActualizacion
                            tipoPersonaEsperado="FISICA"
                            identificacion={identificacionArca(state.entity.documentos, true, cabecera)}
                            filas={FilasArca}
                            verificarFilas={DocumentosArcaDeOtrasPersonas}
                            onAplicar={AplicarArca}
                            onCerrar={actualizacionArca.cerrar}
                        />
                    }

                    <div className='accordion-header'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('datos')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.datos) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.datos ? 'active' : ''}>Datos</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.datos &&
                    <div className='accordion-body'>
                        <div className="form-content">
                            <div className='row'>
                                <div className='img-content img-foto mb-3 col-md-2'>
                                    <img
                                        src={getFoto(formValues.idGenero, formValues.foto)}
                                        alt="Foto"
                                        className='img-fluid img-foto-size'
                                        onClick={(event) => {
                                            if (state.mode !== OPERATION_MODE.VIEW) {
                                                refInputFileFoto.current.click();
                                            }
                                        }}
                                    />
                                    {(state.mode !== OPERATION_MODE.VIEW && formValues.foto.length > 0 &&
                                    <div onClick={ (event) => handleClickRermoveFoto() } className="link">
                                        <span className="material-symbols-outlined" title="Quitar logo">close</span>

                                    </div>
                                    )}

                                    <input
                                        ref={refInputFileFoto}
                                        type="file"
                                        multiple={false}
                                        hidden
                                        onChange={handleInputFileFotoChange}
                                    />
                                </div>
                                <div className='container-fluid mt-3 col-md-10'>
                                    <div className='row'>
                                        <div className="col-6 col-md-4">
                                            <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                                            <input
                                                name="nombre"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                                value={ formValues.nombre }
                                                onChange={({target}) =>{
                                                    formSet({...formValues, nombre: target.value});
                                                    setPendingChange(true);
                                                }}
                                                disabled={verifiedData || ((actualizacionArca.bloqueado('nombre') || arca.isArcaField('nombre')) && !arcaNombreIncompleto) || state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError message={errorOf('nombre')} />
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <FormLabel htmlFor="apellido" required>Apellido</FormLabel>
                                            <input
                                                name="apellido"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('apellido') ? 'is-invalid' : ''}`}
                                                value={ formValues.apellido }
                                                onChange={({target}) =>{
                                                    formSet({...formValues, apellido: target.value});
                                                    setPendingChange(true);
                                                }}
                                                disabled={verifiedData || ((actualizacionArca.bloqueado('apellido') || arca.isArcaField('apellido')) && !arcaNombreIncompleto) || state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError message={errorOf('apellido')} />
                                        </div>
                                        <div className="col-6 col-md-2">
                                            <FormLabel htmlFor="idGenero" required>Género</FormLabel>
                                            <InputLista
                                                name="idGenero"
                                                placeholder=""
                                                className={`form-control ${errorOf('idGenero') ? 'is-invalid' : ''}`}
                                                value={ formValues.idGenero }
                                                onChange={ formHandleProxy }
                                                disabled={state.mode === OPERATION_MODE.VIEW || actualizacionArca.bloqueado('idGenero')}
                                                lista="Genero"
                                            />
                                            <FormError message={errorOf('idGenero')} />
                                        </div>
                                        <div className="col-6 col-md-2">
                                            <label htmlFor="idEstadoCivil" className="form-label">Estado civil</label>
                                            <InputLista
                                                name="idEstadoCivil"
                                                placeholder=""
                                                className="form-control"
                                                value={ formValues.idEstadoCivil }
                                                onChange={ formHandleProxy }
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                lista="EstadoCivil"
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-md-2">
                                                    <FormLabel htmlFor="idNacionalidad" required>Nacionalidad</FormLabel>
                                                    <InputEntidad
                                                        name="idNacionalidad"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('idNacionalidad') ? 'is-invalid' : ''}`}
                                                        value={ formValues.idNacionalidad }
                                                        onChange={ formHandleProxy }
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                        entidad="Pais"
                                                        tipName={TIPS.NAME.MODALS.NACIONALIDAD_MODAL}
                                                    />
                                                    <FormError message={errorOf('idNacionalidad')} />
                                                </div>
                                        <div className="col-6 col-md-4 col-xl-2">
                                            <label htmlFor="fechaNacimiento" className="form-label">Fecha de nacimiento</label>
                                            <DatePickerCustom
                                                name="fechaNacimiento"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaNacimiento') ? 'is-invalid' : ''}`}
                                                value={ formValues.fechaNacimiento }
                                                onChange={ formHandleProxy }
                                                disabled={verifiedData || state.mode === OPERATION_MODE.VIEW || actualizacionArca.bloqueado('fechaNacimiento')}
                                                maxValue={maxFechaNacimiento}
                                            />
                                            <FormError message={errorOf('fechaNacimiento')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-xl-2">
                                            <label htmlFor="fechaDefuncion" className="form-label">Fecha de defunción</label>
                                            <DatePickerCustom
                                                name="fechaDefuncion"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaDefuncion') ? 'is-invalid' : ''}`}
                                                value={ formValues.fechaDefuncion }
                                                onChange={ formHandleProxy }
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaDefuncion')} />
                                        </div>
                                        <div className="col-6 col-md-4 align-self-end">
                                            <CheckboxButton
                                                name="discapacidad"
                                                label="Posee discapacidad"
                                                checked={formValues.discapacidad}
                                                onChange={formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-4 col-xl-2">
                                            <InputSecret
                                                title="PIN"
                                                name="pin"
                                                value={formValues.pin}
                                                onChange={formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxLength={20}
                                            />
                                            <FormError />
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                    )}


                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('documentos')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.documentos) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.documentos ? 'active' : ''}>Documentos</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.documentos &&
                    <div className='accordion-body'>
                        <DocumentosGrid
                            processKey={processKey}
                            disabled={verifiedData || state.mode === OPERATION_MODE.VIEW}
                            data={{
                                idTipoPersona: 500, //PersonaFisica
                                idPersona: state.id,
                                list: state.entity.documentos
                            }}
                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                        />
                    </div>
                    )}

                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('contactos')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.contactos) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.contactos ? 'active' : ''}>Información de contacto</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.contactos &&
                    <div className='accordion-body'>
                        <ContactosGrid
                            processKey={processKey}
                            disabled={state.mode === OPERATION_MODE.VIEW}
                            disabledIds={idEmailAlta ? [idEmailAlta] : []}
                            data={{
                                entidad: 'PersonaFisica',
                                idEntidad: state.id,
                                list: state.entity.contactos
                            }}
                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                        />
                    </div>
                    )}
                                        
                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('direcciones')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.direcciones) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.direcciones ? 'active' : ''}>Domicilio personal</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={(state.accordions.direcciones) ? "accordion-body" : "accordion-hide"}>
                        <div className='row form-basic'>
                            <div className="col-12">
                                <DireccionForm
                                    key={`dir_${arca.arcaData ? 'arca' : domicilioArca ? `arca${domicilioArca.vez}` : 'manual'}`}
                                    id="PersonaFisica_direccion"
                                    data={{
                                        entity: state.entity.direccion
                                    }}
                                    disabled={state.mode === OPERATION_MODE.VIEW || (state.mode === OPERATION_MODE.EDIT && actualizacionArca.bloqueado('direccion'))}
                                    autoGeocode={!!arcaAutoGeocodeAddress}
                                    autoGeocodeAddress={arcaAutoGeocodeAddress}
                                    initFormEdit={state.mode === OPERATION_MODE.NEW}
                                    setPendingChange={setPendingChange}
                                />
                            </div>
                        </div>
                    </div>

                    {accessMedioPago.view &&
                    <>
                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('mediosPago')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.mediosPago) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.mediosPago ? 'active' : ''}>Medios de pago</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.mediosPago &&
                    <div className='accordion-body'>
                        <MediosPagoGrid
                            processKey={processKey}
                            disabled={state.mode === OPERATION_MODE.VIEW || !accessMedioPago.edit}
                            data={{
                                idTipoPersona: 500, //PersonaFisica
                                idPersona: state.id,
                                list: state.entity.mediosPago
                            }}
                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                        />
                    </div>
                    )}
                    </>
                    }
                    
                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('datosImpositivos')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.datosImpositivos) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.datosImpositivos ? 'active' : ''}>Datos impositivos</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.datosImpositivos &&
                    <div className='accordion-body'>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="idCondicionFiscal" className="form-label">Condición fiscal</label>
                                <InputLista
                                    name="idCondicionFiscal"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.idCondicionFiscal }
                                    onChange={ formHandleProxy }
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    lista="CondicionFiscal"
                                />
                            </div>
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="idIngresosBrutos" className="form-label">Inscripción ingresos brutos</label>
                                <InputLista
                                    name="idIngresosBrutos"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.idIngresosBrutos }
                                    onChange={ formHandleProxy }
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    lista="IngresosBrutos"
                                />
                            </div>
                            <div className="col-12 col-md-4 col-lg-3 align-self-end mb-3">
                                <CheckboxButton
                                    name="ganancias"
                                    label="Inscripto en Ganancias"
                                    checked={formValues.ganancias}
                                    onChange={formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                            </div>

                        </div>
                    </div>
                    )}
                    
                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordion('estudios')}>
                                <div className='accordion-header-title'>
                                    {(state.accordions.estudios) ? accordionOpen : accordionClose}
                                    <h3 className={state.accordions.estudios ? 'active' : ''}>Estudios y profesión</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.accordions.estudios &&
                    <div className='accordion-body'>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="idNivelEstudio" className="form-label">Nivel de estudio</label>
                                <InputLista
                                    name="idNivelEstudio"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.idNivelEstudio }
                                    onChange={ formHandleProxy }
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    lista="NivelEstudio"
                                />
                            </div>
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="profesion" className="form-label">Profesión</label>
                                <input
                                    name="profesion"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.profesion }
                                    onChange={ formHandleProxy }
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="matricula" className="form-label">Matrícula</label>
                                <input
                                    name="matricula"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    value={ formValues.matricula }
                                    onChange={ formHandleProxy }
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    maxLength={50}
                                />
                            </div>
                            
                        </div>
                    </div>
                    )}

                    <div className='accordion-header m-top-20'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleAccordionInfo()}>
                                <div className='accordion-header-title'>
                                    {(state.showInfo) ? accordionOpen : accordionClose}
                                    <h3 className={state.showInfo ? 'active' : ''}>Información adicional</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(state.showInfo &&
                    <div className='accordion-body'>
                        <DataTaggerFormRedux
                            title="Información adicional de persona física"
                            processKey={processKey}
                            entidad="PersonaFisica"
                            idEntidad={state.id}
                            disabled={state.mode === OPERATION_MODE.VIEW}
                            onChange={(row) => setPendingChange(true)}
                        />
                    </div>
                    )}

                </div>
            </section>
        </div>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn back-button float-start" onClick={ (event) => handleClickVolver() }>Volver</button>
                {state.mode !== OPERATION_MODE.VIEW &&
                    <button
                        className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                        onClick={ (event) => handleClickGuardar() }
                        disabled={!pendingChange}
                    >
                        Guardar
                    </button>
                }
            </div>
        </footer>
        </>)}

    </>
    )
}

export default PersonaFisicaView;
